import { useNavigate } from "react-router-dom";
import _ from "lodash";
import ImageLinks from "../../../assets/Images/ImagesLink";
import utils from "../../../resources/utils";
import { ChevronRight } from "../../../assets/whiteLabelIcon";
import { useTranslation } from "react-i18next";

const TotalPackage = ({ order_stats, is_loading }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-start px-5 py-5 w-full bg-white rounded-lg shadow-[0px_0px_8px_rgba(166,166,166,0.25)]">
      <div className="flex justify-between items-center w-full">
        <div className="flex gap-1.5">
          <img
            loading="lazy"
            src={ImageLinks.round_track_changes}
            alt=""
            className="object-contain shrink-0 w-5 aspect-square"
          />
          <p className="font-custom text-sm font-semibold text-dark_black">
            {t("active_packages")}
          </p>
        </div>
        <div
          className={`disabled py-1 px-2 flex items-center`}
          style={{
            backgroundColor: utils.convert_hex_to_rgba("#FCF0DB", 50),
            borderRadius: 50,
            pointerEvents: order_stats?.pending == 0 ? "none" : "",
          }}
          onClick={() => navigate("/pending-orders")}
        >
          <p className="font-custom font-medium text-[10px] text-light_orange">
            {order_stats?.pending} {t("orders_pending")}
          </p>
          <ChevronRight fill_color={"#F2C16B"} />
        </div>
      </div>

      {!is_loading &&
      order_stats?.ready_to_ship == 0 &&
      order_stats?.shipped == 0 ? (
        <div className="flex flex-col justify-center w-full p-6 items-center text-center">
          <p className="font-custom text-xs font-medium text-dark_gray">
            {t("looks_like_you_have_no_packages_out_for_pickup_or_delivery")}
          </p>
          {/* <p className="font-custom text-xs font-medium text-dark_gray">
            Looks like you have no packages out for
          </p> */}
          {/* <p className="font-custom text-xs font-medium text-dark_gray">
            pre-pickup / on-delivery.
          </p> */}
        </div>
      ) : (
        <div className="flex overflow-hidden gap-4 mt-4 w-full">
          <div
            className="flex overflow-hidden flex-col items-start pt-2 pr-2 pb-3 pl-5 bg-white rounded-lg border border-solid border-accents border-opacity-20 shadow-[0px_0px_4px_rgba(166,166,166,0.25)] w-[50%]"
            onClick={() => navigate("/order-track-list")}
          >
            <div className="flex justify-end w-full">
              <img
                loading="lazy"
                src={ImageLinks.chevron_right}
                style={{ transform: `rotate(180deg)` }}
                alt=""
                className="object-contain shrink-0 self-start w-2.5 aspect-square"
              />
            </div>
            <div>
              <p className="font-custom text-[10px] font-medium">
                {t("pre_pickup")}
              </p>
            </div>
            <p className="mt-4 text-xl font-semibold text-secondary">
              {order_stats?.ready_to_ship || 0}
            </p>
          </div>
          <div
            className="flex overflow-hidden flex-col items-start pt-2 pr-2 pb-3 pl-5 bg-white rounded-lg border border-solid border-accents border-opacity-20 shadow-[0px_0px_4px_rgba(166,166,166,0.25)] w-[50%]"
            onClick={() => navigate("/order-track-list?tab=OUT_FOR_DELIVERY")}
          >
            <div className="flex justify-end w-full">
              <img
                loading="lazy"
                src={ImageLinks.chevron_right}
                style={{ transform: `rotate(180deg)` }}
                alt=""
                className="object-contain shrink-0 self-start w-2.5 aspect-square"
              />
            </div>
            <div>
              <p className="font-custom text-[10px] font-medium">
                {t("on_delivery")}
              </p>
            </div>
            <p className="mt-4 text-xl font-semibold text-secondary">
              {order_stats?.shipped || 0}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default TotalPackage;
